import { useTheme } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Sent = () => {
  var {
    colors
  } = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    height: "100%",
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "71.8068",
      cy: "72.2529",
      r: "54",
      fill: colors.illustration.light
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40.1499 81.8688L39.6753 81.0467L38.1734 81.9138L17.726 67.7509C16.3402 66.791 16.6907 64.6524 18.3104 64.1851L119.384 35.0265L119.385 35.0262L119.385 35.0264L61.7165 113.614C60.8624 114.778 59.0939 114.681 58.372 113.43L48.0823 95.6081C48.1781 95.7963 48.1107 96.0287 47.9256 96.1355L37.6994 102.04C36.1611 102.928 34.3147 101.519 34.7646 99.8011L39.4283 81.9866C39.5169 81.6481 39.9635 81.5811 40.1499 81.8688Z",
      fill: colors.illustration.bg
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M120.974 36.2414C121.399 35.6843 121.515 34.924 121.225 34.2435C120.829 33.3133 119.802 32.8246 118.83 33.1048L17.7561 62.2636C14.5166 63.1981 13.8156 67.4753 16.5872 69.3951L36.9625 83.508L32.8298 99.2946C31.9301 102.731 35.6228 105.548 38.6994 103.772L47.5394 98.6679L56.64 114.431C58.0838 116.931 61.6206 117.125 63.329 114.797L120.974 36.2414ZM49.8041 94.5892C49.813 94.6046 49.8217 94.6201 49.8303 94.6357L60.1041 112.431L112.14 41.5185L42.4078 81.7784L49.8041 94.5892ZM36.6994 100.308L40.3765 86.2614L45.5394 95.2038L36.6994 100.308ZM38.2707 79.5483L104.184 41.4933L18.8648 66.1068L38.2707 79.5483ZM6.28183 97.6763C5.23599 98.0189 4.67131 99.1496 5.02059 100.202C5.36987 101.254 6.50083 101.829 7.54668 101.486L23.2871 96.3293C24.333 95.9867 24.8976 94.856 24.5484 93.8039C24.1991 92.7518 23.0681 92.1766 22.0223 92.5193L6.28183 97.6763ZM33.0454 131.808C32.0417 131.337 31.6101 130.149 32.0813 129.155L39.1733 114.186C39.6445 113.192 40.8402 112.767 41.8439 113.238C42.8475 113.708 43.2792 114.896 42.808 115.891L35.7159 130.859C35.2447 131.854 34.0491 132.279 33.0454 131.808ZM7.98896 121.216C7.14113 121.903 7.04387 123.147 7.7717 123.996C8.49954 124.845 9.77687 124.977 10.6247 124.29L28.2226 110.044C29.0705 109.358 29.1677 108.113 28.4399 107.264C27.7121 106.416 26.4347 106.284 25.5869 106.97L7.98896 121.216Z",
      fill: colors.illustration.stroke
    })]
  });
};
//# sourceMappingURL=Sent.js.map